import { Component, ChangeDetectionStrategy } from '@angular/core';

import type { User } from '@core/account-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { AvatarComponent } from '@core/user-interface-legacy';

/*
 eslint-disable
 @typescript-eslint/consistent-type-assertions,
 @angular-eslint/no-inputs-metadata-property,
*/

@Component({
  imports: [AvatarComponent, TranslatePipe, AvatarComponent],
  template: `
    @if (user && !user.anonymizedAt) {
      <rt-avatar
        [type]="user?.hasAvatar ? 'image' : 'initials'"
        size="small-x"
        [imageSrc]="user.photoThumbUrl"
        [initials]="$safeNavigationMigration(user?.initials)"
        margin-right-small-xx
        context="admin"
      />
    }
    @if (!user || user.anonymizedAt) {
      <rt-avatar
        type="icon"
        size="small-x"
        context="admin"
        iconName="person"
        margin-right-small-xx
      />
    }
    {{
      user && !user.anonymizedAt
        ? user.firstName + ' ' + user.lastName
        : ('app.common.deleted_user' | translate)
    }}
  `,
  styleUrls: ['./user-cell.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  inputs: UserCellComponent.NgInputs,
})
export class UserCellComponent {
  public static NgInputs = ['user' as const];
  public user: User;
}
